import type { IconData } from '@stacksjs/iconify-core'

export const ribbon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M371 8q19 0 33 13t13 34v676q0 12-11 17t-20-3L212 591q-4-3-7 0L31 745q-9 8-20 3T0 731V55q0-20 14-34T46 8z\"/>",
  "width": 420,
  "height": 850,
  "viewBox": "0 0 420 850"
}

export default ribbon
